<mat-drawer-container class="dashboard">
    <mat-drawer-content>
        <div class="dashboard__content">
            <router-outlet></router-outlet>
        </div>
    </mat-drawer-content>
</mat-drawer-container>
